import React from "react"
import { FormattedMessage } from "react-intl"
import { DbgPaths, Paths } from "#/utils/Paths"
import { InternalIcon, Link, Stack, Tile, Typography } from "@carrotfertility/carotene-core"

const SupportModule = () => {
  return (
    <Tile variant="secondary" color="blue">
      <Stack>
        <Typography variant="h5" component="h3" color="text.secondary">
          <FormattedMessage defaultMessage="Before using your funds" />
        </Typography>

        <Typography variant="body1" color="text.secondary" paddingTop={(theme) => theme.tokens.spacing.xxs}>
          <Link endIcon={<InternalIcon fontSize="small" color="primary" />} href={DbgPaths.CARROT_ELIGIBLE}>
            <FormattedMessage defaultMessage="Understand your coverage" />
          </Link>
        </Typography>

        <Typography variant="body1" color="text.secondary" paddingTop={(theme) => theme.tokens.spacing.xxs}>
          <Link endIcon={<InternalIcon fontSize="small" color="primary" />} href={DbgPaths.PROVIDER_ELIGIBILITY}>
            <FormattedMessage defaultMessage="Make sure your provider is eligible" />
          </Link>
        </Typography>

        <Typography variant="body1" color="text.secondary" paddingTop={(theme) => theme.tokens.spacing.xxs}>
          <Link endIcon={<InternalIcon fontSize="small" color="primary" />} href={DbgPaths.REQUIRED_DOCS}>
            <FormattedMessage defaultMessage="Review documentation requirements" />
          </Link>
        </Typography>

        <Typography variant="body1" color="text.secondary" paddingTop={(theme) => theme.tokens.spacing.xxs}>
          <Link endIcon={<InternalIcon fontSize="small" color="primary" />} href={DbgPaths.TAXES}>
            <FormattedMessage defaultMessage="Learn about Carrot and taxes" />
          </Link>
        </Typography>

        <Typography variant="h6" component="h3" color="text.secondary" marginTop={(theme) => theme.tokens.spacing.lg}>
          <FormattedMessage defaultMessage="Need help?" />
        </Typography>

        <Typography variant="body1" color="text.secondary" paddingTop={(theme) => theme.tokens.spacing.xxs}>
          <Link endIcon={<InternalIcon fontSize="small" color="primary" />} href={Paths.CARE_TEAM}>
            <FormattedMessage defaultMessage="Talk to Carrot" />
          </Link>
        </Typography>
      </Stack>
    </Tile>
  )
}

export { SupportModule }
